import { InvoiceFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const useGetEmailValues = () => {
  const getEmailValues = (
    customerResult: WintSuperkollAPIModel.Customer,
    referencePersonEmail: string | undefined,
    sendMailOptions: InvoiceFormTypes.SendMailOptions
  ) => {
    const mailOptions: InvoiceFormTypes.SendMailOptions = {
      ...sendMailOptions,
      defaultEmailTo: {
        customer: customerResult.emailAddress,
        referencePerson: referencePersonEmail,
      },
    };

    const mailOptionsAuto = { ...mailOptions };
    if (mailOptionsAuto?.emailFromType === WintSuperkollAPIModel.SendInvoiceMailsFromEnum.PersonMail) {
      mailOptionsAuto.emailFromType = undefined;
    }

    const defaultEmailToSettings: InvoiceFormTypes.DefaultEmailToSettings = {
      emailToType: customerResult.invoiceDeliverySettings?.invoiceMailToType,
      customEmail: customerResult.invoiceDeliverySettings?.customInvoiceMailTo,
    };

    const defaultReminderEmailToSettings: InvoiceFormTypes.DefaultEmailToSettings = {
      emailToType: customerResult.invoiceReminderSettings?.invoiceReminderMailToType,
      customEmail: customerResult.invoiceReminderSettings?.customInvoiceReminderMailTo,
    };

    return { mailOptions, mailOptionsAuto, defaultEmailToSettings, defaultReminderEmailToSettings };
  };

  return getEmailValues;
};
